<template>
  <div class="auth-layout">
    <slot />
  </div>
</template>

<script>
export default {
  name: "AuthLayout",
};
</script>

<style lang="scss" scoped>
.auth-layout {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

@media (max-width: 786px) {
  .auth-layout {
    padding: 10rem 1rem;
    max-width: 100%;
    overflow: hidden;
    height: calc(100vh - 4rem);
  }
}
</style>
